import script from "./AddCouponForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCouponForm.vue?vue&type=script&setup=true&lang=js"

import "./AddCouponForm.vue?vue&type=style&index=0&id=1238bffc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1238bffc"]])

export default __exports__